module.exports = __webpack_public_path__ + "static/img/71.3e2c8ee9.jpg";